import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { UnstyledLink } from '../../../typography/UnstyledLink'
import { Link } from '../../../typography/Link'
import { Tag } from '../../../tag'
import { JobListing } from './JobListing'
import * as styles from './DepartmentSection.module.scss'

const DepartmentSection = ({ department, jobs, i, length }) => {
  const filteredJobs = jobs.jobs
  return (
    <div className={i === length - 1 ? styles.lastDepartmentContainer : styles.departmentContainer}>
      <td className={styles.titleContainer}>
        <p>{department}</p>
      </td>
      <div className={styles.listingsContainer}>
        {/* This div will show all of the jobs in the department. Planning to map the jobs array onto the job listing component */}
        {filteredJobs.map(job => {
          return (
            <JobListing
              index="0"
              roleTitle={job.role}
              location={job.location}
              type={job.roleType}
              link={job.absoluteURL}
            />
          )
        })}
      </div>
    </div>
  )
}

DepartmentSection.propTypes = {
  department: PropTypes.string,
  // jobs: PropTypes.array,
}

export { DepartmentSection }
export default DepartmentSection
